//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"Approach",1,0],[0,"Common",1,0],[0,"Crossover",1,0],[0,"Cut",1,0],[0,"Departure",1,0],[0,"Engage",1,0],[0,"FirstCut",1,0],[0,"LastCut",1,0],[0,"Rapid",1,0],[0,"Retract",1,0],[0,"ReturnColor",1,0],[0,"SideCut",1,0],[0,"Stepover",1,0],[0,"Traversal",1,0]],[[[],"SetAllCommonColor",{},0,0]],[]];
SPLM.CAM.PathDisplayColors = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.PathDisplayColors";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;